import { getFirebaseApp } from './firebase';

const CHANNEL_COLLECTION = 'feeds';
const MAPPING_COLLECTION = 'feeds-mapping';

export const addChannel = async (channelData) => {
  const firebaseApp = await getFirebaseApp();
  return firebaseApp.firestore().collection(CHANNEL_COLLECTION).add(channelData);
};

export const listenToChannels = async (onSnapshotCallback, onSnapshotErrorCallback) => {
  const firebaseApp = await getFirebaseApp();
  return firebaseApp
    .firestore()
    .collection(CHANNEL_COLLECTION)
    .onSnapshot(onSnapshotCallback, onSnapshotErrorCallback);
};

export const listenToChannel = async (channelId, onSnapshotCallback) => {
  const firebaseApp = await getFirebaseApp();
  return firebaseApp
    .firestore()
    .collection(CHANNEL_COLLECTION)
    .doc(channelId)
    .onSnapshot(onSnapshotCallback);
};

export const changeChannelStatus = async (channelId, live) => {
  const firebaseApp = await getFirebaseApp();
  return firebaseApp
    .firestore()
    .collection(CHANNEL_COLLECTION)
    .doc(channelId)
    .update({ live: live });
};

export const updateChannelTitle = async (channelId, newName) => {
  const firebaseApp = await getFirebaseApp();
  return firebaseApp
    .firestore()
    .collection(CHANNEL_COLLECTION)
    .doc(channelId)
    .update({ title: newName })
    .then((docRef) => {
      return docRef;
    });
};

export const updateScribbleChannel = async (channelId, scribbleId) => {
  const firebaseApp = await getFirebaseApp();
  return firebaseApp
    .firestore()
    .collection(CHANNEL_COLLECTION)
    .doc(channelId)
    .update({ scribbleChannel: scribbleId })
    .then((docRef) => {
      return docRef;
    });
};

export const updateChannelFeedId = async (channelId, feed) => {
  const firebaseApp = await getFirebaseApp();
  return firebaseApp
    .firestore()
    .collection(CHANNEL_COLLECTION)
    .doc(channelId)
    .update({ feedId: feed })
    .then((docRef) => {
      return docRef;
    });
};

export const addMapping = async (channelId, newUrl) => {
  const firebaseApp = await getFirebaseApp();
  const mappingRef = firebaseApp.firestore().collection(MAPPING_COLLECTION).doc(channelId);

  const mapping = await mappingRef.get();
  if (!mapping.exists) {
    await mappingRef.set({ urls: [] });
  }

  return mappingRef
    .update({
      urls: firebaseApp.firebase_.firestore.FieldValue.arrayUnion(newUrl),
    })
    .then((docRef) => {
      return docRef;
    });
};

export const removeMappingUrl = async (mappingId, url) => {
  const firebaseApp = await getFirebaseApp();
  return firebaseApp
    .firestore()
    .collection(MAPPING_COLLECTION)
    .doc(mappingId)
    .update({
      urls: firebaseApp.firebase_.firestore.FieldValue.arrayRemove(url),
    })
    .then((docRef) => {
      return docRef;
    });
};

export const listenToChannelMappingIds = async (onSnapshotCallback) => {
  const firebaseApp = await getFirebaseApp();
  return firebaseApp.firestore().collection(MAPPING_COLLECTION).onSnapshot(onSnapshotCallback);
};
